import { render } from "./k-chart-repeater.vue?vue&type=template&id=6ca64284"
import script from "./k-chart-repeater.vue?vue&type=script&lang=js"
export * from "./k-chart-repeater.vue?vue&type=script&lang=js"

import "./k-chart-repeater.vue?vue&type=style&index=0&id=6ca64284&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__